import store from "../../../../store";
import { OPTION_CHAINTOOL, OPTION_CHAINTOOL_ERROR, OPTION_CHAINTOOL_HIDE_ERROR, OPTION_CHAINTOOL_START_LOADER, OPTION_CHAINTOOL_STOP_LOADER, } from "../interface/iOptionChainTool";
class OptionChainToolActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getOptionChainToolData(data) {
        this.dispatch({
            type: OPTION_CHAINTOOL,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: OPTION_CHAINTOOL_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: OPTION_CHAINTOOL_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: OPTION_CHAINTOOL_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: OPTION_CHAINTOOL_STOP_LOADER,
        });
    }
}
export default OptionChainToolActions;
